<template>
  <div class="box box-remark">
    <span class="title color-dark fs-16 fw-600">Remarks</span>
    <div class="remarks-container">
      <div
        v-for="(item, index) in remarkDetail"
        :key="index"
        class="remark-box">
        <div class="remark-header">
          <span class="fs-12">{{ item.agent }}</span>
          <span>{{ item.created_at }}</span>
        </div>
        <p>{{ item.message }}</p>
      </div>
    </div>
    <div class="remark-add">
      <v-input
        v-model="message"
        class="mg-b-15"
        append="Add"
        :placeholder="'Add Remarks'"
        @handlerAppend="handlerSendRemark"/>
    </div>
  </div>
</template>

<script>
import {addTicketRemark, getTicketRemark} from '@api/ticket'
import {quoteRemarkAdd} from '@api/quote'
import {addPolicyRemark} from '@api/policy'

export default {
  name: 'TicketRemark',
  props:{
    ticketId:{
      type:[String,Number],
      default:0
    },
    quoId:{
      type:[String,Number],
      default:0
    },
    pcyId:{
      type:[String,Number],
      default:0
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    isPolicy: {
      type: Boolean,
      default: false
    },
    remark: {
      type: Array,
      default: () => ([])
    },
  },
  data(){
    return{
      message:'',
      remarkDetail:[]
    }
  },
  watch:{
    remark:{
      immediate:true,
      handler(val){
        if(val){
          this.remarkDetail = val||[]
        }
      }
    }
  },
  mounted() {
    if(!this.isQuote&&!this.isPolicy)
      this.network().getRemarkDetail()
  },
  methods:{
    handleUpdateRemark(){
      if(!this.isQuote&&!this.isPolicy)
        this.network().getRemarkDetail()
    },
    handlerSendRemark(msg) {
      let content = msg? msg : this.message
      if(this.isPolicy){
        this.network().addPolicyRemark()
        return
      }
      if(this.isQuote){
        this.network().quoteRemarkAdd()
        return
      }
      this.network().addTicketRemark({
        ticket_id: this.ticketId,
        hideLoading:true,
        content
      })
    },
    network(){
      return{
        getRemarkDetail: async (params) => {
          if(this.ticketId)
          {
            const { data } = await getTicketRemark({
              ticket_id: this.ticketId,
            })
            this.remarkDetail = data
          }
        },
        addPolicyRemark: async () => {
          const { data } = await addPolicyRemark({
            pcy_id: this.pcyId,
            message: this.message
          })
          this.message = ''
          this.remarkDetail.unshift(data)
        },
        addTicketRemark: async params => {
          const { data } = await addTicketRemark(params)
          this.message = ''
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.$emit('refresh')
          this.network().getRemarkDetail({hideLoading:true})
        },
        quoteRemarkAdd: async (params = {}) => {
          const { data } = await quoteRemarkAdd({
            quo_id: this.quoId,
            message: this.message ,
          })
          this.message = ''
          this.$message({
            type: 'success',
            message:'Success'
          })
          this.remarkDetail.unshift(data)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box-remark{
  border-bottom: 0!important;
}
.remark-add {
  z-index: 2;
  margin: 0 -15px;
  padding: 15px 15px 0 15px;
  //border-top: 1px solid #dddfe7;
}

.remarks-container {
  z-index: 1;
  max-height: 300px;
  overflow-y: auto;

  .remark-box {
    margin-bottom: 10px;
    font-size: 12px;
    color: #91939a;

    .remark-header {
      display: flex;
      justify-content: space-between;

      span:first-child {
        font-weight: bold;
      }
    }

    p {
      padding-bottom: 10px;
      color: #616266;
    }
  }
}
</style>
